import { render, staticRenderFns } from "./GradCarousel.vue?vue&type=template&id=4ec85951&"
import script from "./GradCarousel.vue?vue&type=script&lang=js&"
export * from "./GradCarousel.vue?vue&type=script&lang=js&"
import style0 from "./GradCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports